import { RG_TYPE as c } from "@project-rouge/rg-core";
const i = (a) => (t, e) => {
  if (e && a.apartments[e.name])
    return a.apartments[e.name];
  if (a.apartments[t.name])
    return a.apartments[t.name];
  if (e && e.type === c.TechnicalSpace) {
    const n = e;
    if (n.data.instance.spaceClass)
      return a.techSpaces[n.data.instance.spaceClass];
  }
  if (t.type === c.TechnicalSpace) {
    const n = t;
    if (n.data.instance.spaceClass)
      return a.techSpaces[n.data.instance.spaceClass];
  }
  return a.rgTypes[t.type];
};
export {
  i as getChangeColorFunc
};
//# sourceMappingURL=index2.js.map
